exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.opdracht-volumes[data-v-347dc61a] {\n    background: #f7f7f7;\n    padding-inline: 20px;\n    padding-block: 8px;\n    margin-inline: -20px;\n    margin-block-start: -20px;\n}\n", ""]);
